import { call, put, select, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { configuration } from '../../../api';
import { loadOidcConfiguration } from '../../../services/auth/oidc';
import { resourceReducer } from '../../utils/resourceReducer';
import { useOidcSelector } from '../selectors/configuration';

export const [actions, reducer, ...resourceSagas] = resourceReducer(
  'configuration',
  {
    // We don't want this to flush when the APP/FLUSH event is dispatched since
    // we always want config to exist
    flushOnAppFlush: false,
  }
);

function* setConfiguration() {
  yield takeEvery(actions.indexRequestBegin, function* ({ payload }) {
    const { args } = payload;
    try {
      const result = yield call(configuration.get, args);
      const normalized = normalize(result);

      yield put(actions.indexRequestSuccess({ ...normalized, args }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error, args }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

// Read the /oidc discovery document once at startup when the remote flag says
// new logins go through the OIDC provider, so the first login does not pay for
// it. It is cached in the auth service; a failure only means the default paths
// are used until it is read lazily on first use.
function* prefetchOidcDiscovery() {
  yield takeEvery(actions.indexRequestSuccess, function* () {
    const useOidc = yield select(useOidcSelector);
    if (useOidc) {
      yield call(loadOidcConfiguration);
    }
  });
}

export const sagas = [setConfiguration, prefetchOidcDiscovery, ...resourceSagas];
